import ReactLoading from "react-loading";
import { Box, Typography, useTheme } from "@mui/material";

import { useAuthUser } from "context/GameAuthContext";

import { ChatHistory } from "user-dashboard/types";

import { greyColors } from "theme/colors";

import { getInvertColor } from "utils/themeUtils";

import RiddlestoryAIPNG from "./riddlestory-ai.png";

export const ChatHistoryItem = (props: { chatHistory: ChatHistory; aiLogo?: string }) => {
	const user = useAuthUser();
	const theme = useTheme();

	const { chatHistory, aiLogo } = props;

	return (
		<Box>
			{chatHistory.query && (
				<MessageItem text={chatHistory.query} bgColor={theme.palette.primary.main} sender={user.name} />
			)}
			<MessageItem
				text={chatHistory.answer}
				bgColor={greyColors["100"]}
				sender="AI"
				profilePicUrl={aiLogo}
				isTyping={!chatHistory.createdAt} // AI Bot is typing if the chat history doesn't have `createdAt` (Created by the Frontend)
				isAI
			/>
		</Box>
	);
};

const MessageItem = (props: {
	text: string;
	sender: string;
	bgColor: string;
	isTyping?: boolean;
	profilePicUrl?: string;
	isAI?: boolean;
}) => {
	const theme = useTheme();

	const isLight = getInvertColor(theme.palette.primary.main) === "#3C4255";

	return (
		<>
			<Box
				display="flex"
				alignItems="center"
				gap="1.2rem"
				padding="0.8rem 0"
				textAlign="left"
				sx={{
					wordBreak: "break-word",
					whiteSpace: "pre-line",
					justifyContent: props.isAI ? "flex-start" : "flex-end",
				}}
			>
				{props.isAI && (
					<SenderAvatar>
						{props.isAI ? (
							<img style={{ inlineSize: "100%" }} src={props.profilePicUrl || RiddlestoryAIPNG} alt="" />
						) : (
							props.sender[0]
						)}
					</SenderAvatar>
				)}
				<Box
					display="flex"
					alignItems="center"
					padding="0.8rem 1.6rem"
					maxWidth="70%"
					sx={{
						background: props.bgColor,
						border: (theme) => `1px solid ${theme.palette.grey["200"]}`,
						borderRadius: props.isAI ? "1.6rem 1.6rem 1.6rem 0.4rem" : "1.6rem 0.4rem 1.6rem 1.6rem",
					}}
				>
					{props.isTyping ? (
						<Box>
							<ReactLoading type="balls" color={greyColors["600"]} height="2.4rem" width="2.4rem" />
						</Box>
					) : (
						<Typography
							fontSize="1.6rem"
							color={props.isAI ? "grey.600" : isLight ? "grey.600" : "common.white"}
							dangerouslySetInnerHTML={{ __html: props.text }}
						/>
					)}
				</Box>
			</Box>
		</>
	);
};

const SenderAvatar = ({ children }: { children: React.ReactNode }) => {
	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="center"
			width="3.2rem"
			height="3.2rem"
			sx={{
				overflow: "hidden",
				fontWeight: 500,
				fontSize: "1.6rem",
				color: "common.white",
				border: (theme) => `1px solid ${theme.palette.grey["200"]}`,
				borderRadius: "3.2rem",
				backgroundColor: "common.white",
			}}
		>
			{children}
		</Box>
	);
};
